export default __webpack_public_path__ + "static/media/document-single.b3db5ea9.png";